import React from "react";


import { Col, Row } from "react-bootstrap";


import "./index.scss";


type FormHeaderComponentProps = {
    headerTitle?: string;
    headerDescription?: string;
}


export const FormHeaderComponent:React.FC<FormHeaderComponentProps> = ({
    headerTitle, headerDescription
}) => {


    if (!headerTitle && !headerDescription) {
        return null;
    }


    return (
        <Col xs={12} className={'form-header-component'}>
            <Row className={'form-header-component__content'}>

                {headerTitle &&
                <Col xs={12} className={'form-header-component__header-title'}>
                    <span>{headerTitle}</span>
                </Col>
                }

                {headerDescription &&
                <Col xs={12} className={'form-header-component__header-description'}>
                    <span>{headerDescription}</span>
                </Col>
                }

            </Row>
        </Col>
    );

};


export default FormHeaderComponent;
